var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ed-table',{attrs:{"columns":_vm.columns,"loading":_vm.loading,"data":_vm.tableData,"border":""},on:{"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }